import { getSocketReconnectDelayMs } from '~/utils/sockets/getSocketReconnectDelayMs';

/** Schedules socket connect attempts with n² backoff. Does not stop after a max attempt count. */
export class SocketReconnectScheduler {
  private attempt = 0;
  private timeoutId: ReturnType<typeof setTimeout> | null = null;

  reset = () => {
    this.cancel();
    this.attempt = 0;
  };

  cancel = () => {
    if (this.timeoutId === null) {
      return;
    }

    clearTimeout(this.timeoutId);
    this.timeoutId = null;
  };

  schedule = (connect: () => void) => {
    this.cancel();

    this.timeoutId = setTimeout(
      () => {
        this.timeoutId = null;
        this.attempt += 1;
        connect();
      },
      getSocketReconnectDelayMs({ attempt: this.attempt }),
    );
  };
}
